import settingsList from "./settingsList";
import settingsEdit from "./settingsEdit";
import settingsCreate from "./settingsCreate";
import { SettingsApplications } from "@mui/icons-material";

const Settings = {
  list: settingsList,
  create: settingsCreate,
  edit: settingsEdit,
  icon: SettingsApplications
};
export default Settings;